import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  makeStyles,
  MenuItem,
  TextField,
  Divider,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
//import ProductSelect from "modules/serial-number/components/select/productSelect";
import ProductSearch from "modules/stockflow/components/select/productSearch";
import BranchSearch from "modules/stockflow/components/select/branchSearch";
import { getLang } from "app/feature/constants";
import { Formik } from "formik";
import SerialNumTable from "../../table/serialNumTable";
import AdditionalInfoSearchDialog from "../../dialog/additionalInfoSearchDialog";

const useStyle = makeStyles((theme) => ({
  searchContainer: {
    backgroundColor: theme.palette.background.paper,
    display: "grid",
    gridTemplateColumns: "6fr 1fr 1fr",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  inputRoot: {
    fontWeight: 500,
    paddingTop: "8px !important",
    paddingBottom: "7px !important",
    paddingLeft: "10px !important",
  },
  onFocusBorder: {
    borderRadius: 4,
    outlineWidth: "1px",
    outlineStyle: "solid",
    outlineColor: theme.palette.secondary.main,
  },
  colorIsSelected: {
    background: "#EBEDEE",
  },
  icon: {
    borderRight: "1px solid #3A4D5430",
  },
  dropdownSearchBox: {
    backgroundColor: "#E9EDEF",
    borderRadius: 4,
    width: "100%",
    alignItems: "center",
  },
  select: {
    [theme.breakpoints.down("xs")]: {
      minWidth: "50%",
    },
  },
  divider: {
    height: "70%",
    placeSelf: "center",
  },
  textFieldInput: {
    padding: "7px",
    paddingTop: "8px",
    fontWeight: 500,
    color: theme.palette.primary.main,
    [theme.breakpoints.down("xs")]: {
      minWidth: "50%",
    },
  },
  menuItemText: {
    padding: 10,
    fontWeight: 500,
  },
  filterContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: "0px 16px 12px",
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  infoControlSection: {
    border: "1px solid #c4c4c4",
    borderRadius: 4,
    padding: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyContainer: {
    backgroundColor: "white",
    borderRadius: 4,
    padding: 16,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "calc(100dvh - 365px)",
  },
}));

export default function SnListingPanelComponent({
  snList,
  handleChangePage,
  handleChangeRowsPerPage,
  isFetching,
  length,
  language,
  handleSearch,
  clearSearch,
  handleReload,
  paginationOptions,
  productDropdown,
  lang,
  tableFilter,
  handleViewDetail,
  isSearchResult,
  additionalFields,
}) {
  const classes = useStyle();
  const textRef = useRef();

  const [onFocus, setOnFocus] = useState(false);
  const columnDropdown = [
    { name: getLang(lang, "label.SERIAL_NUMBER"), value: "serial_number" },
    { name: getLang(lang, "label.SEQUENCE_NUMBER"), value: "seq_number" },
  ];

  return additionalFields.length ? (
    <>
      <Formik
        initialValues={{
          searchColumn: tableFilter.searchColumn || columnDropdown[0].value,
          search: tableFilter.search,
          branch: tableFilter.branch,
          products: tableFilter.products,
          productNotAssigned: tableFilter.productNotAssigned,
          additionalInfo: tableFilter.additionalInfo,
        }}
        enableReinitialize
        onSubmit={handleSearch}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <Box p={2} className={classes.searchContainer}>
              <Box
                display="flex"
                className={clsx(classes.dropdownSearchBox, {
                  [classes.onFocusBorder]: onFocus,
                })}
              >
                <TextField
                  style={{ minWidth: "unset" }}
                  className={classes.select}
                  select
                  SelectProps={{
                    MenuProps: {
                      MenuListProps: {
                        style: { padding: 0 },
                      },
                      style: { marginTop: 5 },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    },
                  }}
                  value={formik.values.searchColumn}
                  size="small"
                  margin="none"
                  InputProps={{
                    disableUnderline: true,
                    classes: { input: classes.inputRoot },
                  }}
                >
                  {columnDropdown.map((column, index) => (
                    <MenuItem
                      className={classes.menuItemText}
                      value={column.value}
                      key={index}
                      onClick={() => {
                        formik.setFieldValue("searchColumn", column.value);
                      }}
                    >
                      {column.name}
                    </MenuItem>
                  ))}
                </TextField>
                <Divider orientation="vertical" className={classes.divider} />
                <TextField
                  fullWidth={true}
                  onFocus={() => setOnFocus(true)}
                  onBlur={() => setOnFocus(false)}
                  size="small"
                  margin="none"
                  placeholder={getLang(lang, "placeholder.SEARCH")}
                  inputRef={textRef}
                  InputProps={{
                    disableUnderline: true,
                    margin: "none",
                  }}
                  inputProps={{
                    className: classes.textFieldInput,
                  }}
                  value={formik.values.search}
                  onChange={(event) => {
                    formik.setFieldValue("search", event.target.value);
                  }}
                />
              </Box>
              <Button
                variant="text"
                disableElevation
                color="primary"
                size="small"
                disabled={isFetching}
                onClick={() => {
                  clearSearch();
                }}
              >
                {getLang(lang, "label.CLEAR")}
              </Button>
              <Button
                variant="contained"
                disableElevation
                color="primary"
                size="small"
                type="submit"
                disabled={isFetching}
              >
                {getLang(lang, "label.SEARCH")}
              </Button>
            </Box>
            <Box className={classes.filterContainer}>
              <BranchSearch
                placeholder={getLang(lang, "placeholder.BRANCH")}
                value={formik.values.branch}
                handleChange={(value) => formik.setFieldValue("branch", value)}
                isEmpty={formik.values.branch?.length === 0}
                styles={{
                  padding: "0.25em 0.75em",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: 4,
                  width: "100%",
                  overflow: "hidden",
                  height: 38,
                }}
                disabled={isFetching}
                handleChipDelete={(branch) => {
                  let temp = [...formik.values.branch];
                  if (temp.length > 0) {
                    const filteredBranchs = temp.filter(
                      (item) => item.node_id !== branch.node_id
                    );
                    temp = [...filteredBranchs];
                  }
                  formik.setFieldValue("branch", temp);
                }}
              />
              <ProductSearch
                searchable={true}
                value={formik.values.products}
                isNotAssignSelected={formik.values.productNotAssigned}
                placeholder={getLang(lang, "placeholder.SEARCH_BY_PRODUCT")}
                searchPlaceholder={getLang(
                  lang,
                  "placeholder.SEARCH_A_PRODUCT_NAME"
                )}
                isClearable={false}
                emptyMessage={getLang(lang, "message.info.NO_PRODUCT_FOUND")}
                dropdownItem={productDropdown}
                isEmpty={formik.values.products?.length === 0}
                selectedProduct={formik.values.products}
                style={{
                  padding: "0.25em 0.75em",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: 4,
                  width: "100%",
                  overflow: "hidden",
                  height: 38,
                }}
                handleSelectAll={async (selectAll) => {
                  if (selectAll) {
                    await formik.setFieldValue("products", productDropdown);
                  } else {
                    await formik.setFieldValue("products", []);
                  }
                }}
                handleSelectNotAssigned={(selectNotAssign) => {
                  formik.setFieldValue("products", []);
                  formik.setFieldValue("productNotAssigned", selectNotAssign);
                }}
                handleChange={(value) => {
                  formik.setFieldValue("productNotAssigned", false);

                  let temp = [...formik.values.products];

                  if (temp.length === 0) {
                    temp.push(value);
                  } else {
                    const isProductExist = temp.find(
                      (product) => product.id === value.id
                    );

                    if (isProductExist === undefined) {
                      temp.push(value);
                    } else {
                      let filter = temp.filter(
                        (product) => product.id !== value.id
                      );

                      temp = [...filter];
                    }
                  }
                  formik.setFieldValue("products", [...temp]);
                }}
                handleChipDelete={(product) => {
                  let temp = [...formik.values.products];
                  if (temp.length > 0) {
                    const filteredProducts = temp.filter(
                      (item) => item.id !== product.id
                    );
                    temp = [...filteredProducts];
                  }
                  formik.setFieldValue("products", temp);
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                disabled={isFetching}
              />
              <AdditionalInfoSearchDialog
                additionalFields={additionalFields}
                values={formik.values.additionalInfo}
                disabled={isFetching}
                handleChange={(values) => {
                  formik.setFieldValue(
                    "additionalInfo",
                    values.additionalValues
                  );
                }}
                handleClear={() => {
                  formik.setFieldValue("additionalInfo", []);
                }}
              />
            </Box>
          </form>
        )}
      </Formik>
      <Box mt={2}>
        <SerialNumTable
          isFetching={isFetching}
          listingSerialNumberData={snList}
          rowsPerPage={tableFilter.length}
          page={tableFilter.start}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          length={length}
          language={language}
          handleReload={handleReload}
          paginationOptions={paginationOptions}
          lang={lang}
          handleViewDetail={handleViewDetail}
          isSearchResult={isSearchResult}
          additionalFields={additionalFields}
          showAdditionalInfo={true}
        />
      </Box>
    </>
  ) : (
    <Box className={classes.emptyContainer}>
      <Typography variant="body1">
        {getLang(lang, "paragraph.PLEASE_SELECT_ADT_INFO_VIEW_RESULT")}
      </Typography>
    </Box>
  );
}
